import ApiService from "../../../core/service/ApiService";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Card, Input, List, Select, Space, Table, Typography } from "antd";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";

export default function AppointmentReminder({ patientId }) {
    const history = useHistory();
    const [reminders, setReminders] = useState([]);
    const [filteredData, setFilteredData] = useState([])

    const getReminders = async () => {
        if (!patientId) return;
        const res = await ApiService.Reminder.GetReminderList({ patientId: patientId })

        if (res.success) {
            setReminders(res.data)
        }
    }

    const deleteReminder = async (reminderId) => {
        const res = await ApiService.Reminder.DeleteReminder(reminderId);

        if (res.success) {
            await getReminders();
        }
    }

    useEffect(() => {
        if (patientId) {
            getReminders()
        }
    }, [patientId])

    useEffect(() => {
        setFilteredData(reminders)
    }, [reminders])

    return (
        <Card>
            {<Space style={{ marginBottom: 16 }}>
                <Button size={'small'} onClick={() => { history.push(`/app/system/reminders/create?patientId=${patientId}`) }} type={'primary'}>{t('New')}</Button>
            </Space>}
            <Table
                size={'small'}
                dataSource={filteredData}
                pagination={false}
                columns={[
                    { dataIndex: 'id', key: 'id', title: t('Id') },
                    { dataIndex: 'reminderDate', key: 'reminderDate', title: t('Reminder Date') },
                    { dataIndex: 'note', key: 'note', title: t('Note') },
                    {
                        dataIndex: '#', key: '#', title: t('#'), render: (text, row) => (
                            <Space>
                                <a key="edit" href={`/app/system/reminders/edit/?patientId=${patientId}&reminderId=${row.id}`}>{t('edit')}</a>
                                <a key="delete" onClick={async () => { await deleteReminder(row.id) }} style={{ color: 'red' }}>{t('Delete')}</a>
                            </Space>
                        )
                    },
                ]}
            />
        </Card>
    )
}